import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import StarFillIcon from '@flipster/react/icon/generated/StarFillIcon';
import StarOutlineIcon from '@flipster/react/icon/generated/StarOutlineIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import { SymbolScope } from '../symbol/bunja';
import { favoriteSymbolBunja } from './state';

interface Props {
  symbol: string;
  css?: Styles;
}

export const FavoriteSymbolButton = ({ symbol, css: cssProps }: Props) => {
  const { favoriteAtom, handleFavoriteClick } = useBunja(favoriteSymbolBunja, [SymbolScope.bind(symbol)]);
  const isFavorite = useAtomValue(favoriteAtom);
  return (
    <button
      role='button'
      className={css(center.raw({ pr: 8, cursor: 'pointer' }), cssProps)}
      onClick={(e) => {
        e.stopPropagation();
        handleFavoriteClick();
      }}
    >
      {isFavorite ? (
        <StarFillIcon size={20} color={token('colors.content.state.warning')} />
      ) : (
        <StarOutlineIcon size={20} color={token('colors.content.default.level-1')} />
      )}
    </button>
  );
};
